import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import MembershipPlanSelection from './MembershipPlanSelection'
import LoadingSpinner from '../../../common/loader/legacy-loaders/LoadingSpinner'
import usePaymentSession from '../../../../hooks/usePaymentSession'
import { selectQuote } from '../../../../reducers/programRegistrationReducer'

import './MembershipStep.scss'

const MembershipStep = () => {
  const { t } = useTranslation()
  const quote = useSelector(selectQuote)

  usePaymentSession()

  return (
    <div id='MembershipStep' className='d-flex flex-column'>
      <h3 className='step-title'>{t('programs.registration.membershipStep.title')}</h3>
      <p className='membership-step-subtitle'>{t('programs.registration.membershipStep.instructions')}</p>
      {!quote?.pricing
        ? (
          <LoadingSpinner
            text={t('programs.registration.membershipStep.loading')}
            classNames={{ wrapper: 'membership-step-loader', spinner: 'fa-2x', text: 'loading-payment-form-text' }}
          />
        )
        : <MembershipPlanSelection />}
    </div>
  )
}

export default MembershipStep
